import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  FilterSupplier,
  GenericApiErrors, GetReceivementOverviewListPayload, GetReceivementOverviewListResponse, GetReceivementStatusListPayload, GetReceivementStatusListResponse,
} from './ReceivementOverviewListTypes'

const getReceivementOverviewList = async (payload: GetReceivementOverviewListPayload) => {
  try {
    const { badge, ...filters } = payload
    const result = await http.get('v2/recebimento/list', {
      headers: {
        'user-barcode': badge,
      },
      params: {
        page: filters.page,
        per_page: filters.pageSize,
        fc_active: filters.fcActive,
        id_fc: filters.idFc,
        start_date: filters.startDate.format('YYYY-MM-DD'),
        end_date: filters.endDate.format('YYYY-MM-DD'),
        id_supplier: filters.idSupplier,
        invoice_number: filters.invoiceNumber,
        invoice_key: filters.invoiceKey,
        id_status: filters.idStatus,
        id_ar: filters.idAr,
      },
    })

    return parseGoodResponse<GetReceivementOverviewListResponse>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getReceivementStatusList = async (payload: GetReceivementStatusListPayload) => {
  try {
    const { badge } = payload
    const result = await http.get('v2/recebimento/status/list', {
      headers: {
        'user-barcode': badge,
      },

    })

    return parseGoodResponse<GetReceivementStatusListResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getFilterSuppliers = async () => {
  try {
    const result = await http.get('/v2/recebimento/suppliers')

    return parseGoodResponse<FilterSupplier[]>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getReceivementOverviewList,
  getReceivementStatusList,
  getFilterSuppliers,
}
